import { Trans, useTranslation } from 'react-i18next';

import Button from '@appchoose/button';
import Icon from '@appchoose/icon';
import { ModalFooter, ModalHeader, ModalTitle } from '@appchoose/modal';
import { toast } from '@appchoose/toast';
import { useLocalStorageValue } from '@react-hookz/web';

import { useSubmitReviewsFeatureInterestMutation } from '../../types/generated';

export const RATINGS_RETRIEVAL_SHOWN_KEY = 'ratings-retrieval-shown';

export const RatingsRetrievalModal = ({
  setIsOpen,
}: {
  setIsOpen: (isOpen: boolean) => void;
}) => {
  const { t } = useTranslation();
  const { set: setRatingsRetrievalShown } = useLocalStorageValue(
    RATINGS_RETRIEVAL_SHOWN_KEY,
    {
      initializeWithValue: false,
    }
  );

  const { mutateAsync } = useSubmitReviewsFeatureInterestMutation();

  const handleSubmit = async (isInterested: boolean) => {
    try {
      await mutateAsync({
        isInterested,
      });
    } finally {
      setRatingsRetrievalShown(true);

      toast.success(t('analytics.ratings_retrieval.modal.request_sent'));

      setIsOpen(false);
    }
  };

  return (
    <div className="flex h-full flex-col overflow-hidden">
      <div className="flex-auto overflow-y-auto p-6 md:p-10">
        <ModalHeader>
          <ModalTitle>
            {t('analytics.ratings_retrieval.modal.title')}
          </ModalTitle>
        </ModalHeader>
        <p>
          <Trans
            t={t}
            i18nKey="analytics.ratings_retrieval.modal.description"
            components={{ b: <b className="text-gray-900" /> }}
          />
        </p>
      </div>
      <ModalFooter>
        <Button
          type="button"
          appearance="outline"
          className="gap-2"
          onClick={() => handleSubmit(false)}
        >
          <Icon icon="close" />
          {t('analytics.ratings_retrieval.modal.not_interested')}
        </Button>

        <Button
          type="button"
          className="gap-2"
          onClick={() => handleSubmit(true)}
        >
          <Icon icon="check" />
          {t('analytics.ratings_retrieval.modal.interested')}
        </Button>
      </ModalFooter>
    </div>
  );
};
